import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { OrganizationDetails } from '../models/organization-details.model';
import { IDropdown } from '../models/dropdown.model';
@Injectable({
  providedIn: 'root'
})
export class OrganizationAdminService {
  private readonly apiUrl = '/api/organization-admin';

  constructor(private http: HttpClient) {}

  // Get all organizations
  getOrganizations(): Observable<OrganizationDetails[]> {
    return this.http.get<OrganizationDetails[]>(`${this.apiUrl}/organizations`);
  }

  // Get organization types dropdown
  getOrganizationTypes(): Observable<IDropdown[]> {
    return this.http.get<IDropdown[]>(`${this.apiUrl}/organization-types`);
  }

  // Get states dropdown
  getStates(): Observable<IDropdown[]> {
    return this.http.get<IDropdown[]>(`${this.apiUrl}/states`);
  }

  // Add new organization
  addOrganization(organization: OrganizationDetails): Observable<OrganizationDetails> {
    return this.http.post<OrganizationDetails>(`${this.apiUrl}/organizations`, organization);
  }

  // Update organization
  updateOrganization(organization: OrganizationDetails): Observable<OrganizationDetails> {
    return this.http.put<OrganizationDetails>(`${this.apiUrl}/organizations/${organization.id}`, organization);
  }

  // Delete organization
  deleteOrganization(organizationId: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/organizations/${organizationId}`);
  }

}
